export default function (url) {
    return url.indexOf(process.env.DOMAIN) >= 0 ? 'noreferrer' : 'noopener';
}
